export default Object.freeze({
  CLOUD_FORMATION: 'cloud_formation',
  INSTALL_SCRIPT: 'install_script',
});
